kombi.activeLinks = function () {
  let found = false;
  document.querySelectorAll(".nav-link[href='" + location.pathname + "']").forEach((item) => {
    found = true;
    item.classList.add("active");
  });

  if (!found) {
    if (location.pathname.indexOf("/hotel/") == 0){
      document.querySelectorAll(".nav-link[href='/hotel/']").forEach((item) => {
        item.classList.add("active");
      });
    }
  }


};
